export const sliderIds = new WeakMap();
export function getSliderThumbId(state, index) {
  let id = sliderIds.get(state);

  if (!id) {
    throw new Error('Unknown slider state');
  }

  return `${id}-${index}`;
}
//# sourceMappingURL=utils.js.map